<template>
  <div class="voyage-description-container">
    <ThemedTextField
      label="Description"
      outlined
      persistent-placeholder
      v-model="descriptionModel"
    />
  </div>
</template>

<script>
import { mapState } from "vuex";
import ThemedTextField from "@/core/ThemedTextField.vue";
export default {
  name: "VoyageDescriptionComponent",
  components: {
    ThemedTextField,
  },
  data: function () {
    return {};
  },
  computed: {
    ...mapState("weatherRouting/formModule", ["voyageDescription"]),
    descriptionModel: {
      get() {
        return this.voyageDescription;
      },
      set(value) {
        this.$store.commit(
          "weatherRouting/formModule/SET_VOYAGE_DESCRIPTION",
          value,
          { root: true }
        );
      },
    },
    isPanelOpen() {
      return this.openedPanel.length != 0;
    },
  },
};
</script>

<style scoped>
.voyage-description-container {
  width: 100%;
}
</style>

